/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysaiaProfileSectionNoDetails/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysaiaProfileSectionNoDetails({
  children,
  viewPath = "/DesignSystem/TysiaProfileElements/TysaiaProfileSectionNoDetails"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="TysaiaProfileSectionNoDetails.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-H9f2N': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Not provided"
 weight="semibold"
/>
</div>
{children}
</React.Fragment>)
}